module.exports = __webpack_public_path__ + "img/消息.f866e144.png";